module.exports = __webpack_public_path__ + "img/storyblok.26add4a0.png";